import gql from "graphql-tag"
const CONTACT_US = gql`
    mutation contactUs($name: String!, $email: String!, $message: String!) {
        contactUs(name: $name, email: $email, message: $message)
    }
`;
export {
    CONTACT_US
}